export const FY_END_DATE = '06-30';

export enum FY_REVIEW_PERIOD {
	START = '07-01',
	END = '07-10',
}
